export default __webpack_public_path__ + "static/media/m_foodieBooster09.dbe5e445.png";